(function () {
  function loadSwiper(section, callback) {
    if (window.Swiper) return callback();
    var existing = document.querySelector(
      'script[src*="swiper-bundle.min.js"]',
    );
    if (existing)
      return existing.addEventListener("load", callback, { once: true });
    var script = document.createElement("script");
    script.src = section.dataset.swiperSrc;
    script.onload = callback;
    document.head.appendChild(script);
  }

  function init(section) {
    if (!section || section.sceneSecurityCards) return;
    section
      .querySelectorAll(
        "[data-scene-security-desktop] .scene-security-cards__card",
      )
      .forEach(function (card) {
        card.addEventListener("mouseenter", function () {
          section
            .querySelectorAll(
              "[data-scene-security-desktop] .scene-security-cards__card",
            )
            .forEach(function (item) {
              item.classList.toggle("is-active", item === card);
            });
        });
      });

    var mediaQuery = window.matchMedia("(max-width: 767px)");
    var swiperInstance;
    var resizeObserver;

    function destroySwiper() {
      if (!swiperInstance) return;
      swiperInstance.el.classList.remove("is-mobile-end");
      swiperInstance.destroy(true, true);
      swiperInstance = null;
      if (resizeObserver) resizeObserver.disconnect();
      resizeObserver = null;
    }

    function updateEndState(instance) {
      instance.el.classList.toggle("is-mobile-end", mediaQuery.matches && instance.isEnd && !instance.isBeginning && !instance.isLocked);
    }

    function initSwiper() {
      var swiper = section.querySelector("[data-scene-security-swiper]");
      if (!swiper || !mediaQuery.matches || swiperInstance) return;
      swiperInstance = new Swiper(swiper, {
        slidesPerView: "auto",
        spaceBetween: 12,
        slidesOffsetAfter: 0,
        // Keep swipes starting between cards responsive at the end of the track.
        touchEventsTarget: "container",
        simulateTouch: true,
        resistanceRatio: 0.85,
        // End-state classes change during swipes; observe size, not our own attributes.
        resizeObserver: true,
        watchOverflow: true,
        on: { init: updateEndState, setTranslate: updateEndState, resize: updateEndState, update: updateEndState, lock: updateEndState, unlock: updateEndState },
      });
      if (window.ResizeObserver) {
        resizeObserver = new ResizeObserver(function () {
          if (swiperInstance) swiperInstance.update();
        });
        resizeObserver.observe(swiper);
      }
    }

    function syncSwiper() {
      if (!mediaQuery.matches) return destroySwiper();
      loadSwiper(section, initSwiper);
    }

    section.sceneSecurityCards = { destroy: destroySwiper };
    syncSwiper();
    if (mediaQuery.addEventListener)
      mediaQuery.addEventListener("change", syncSwiper);
    else mediaQuery.addListener(syncSwiper);
  }

  function initAll() {
    document.querySelectorAll("[data-scene-security-cards]").forEach(init);
  }

  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", initAll);
  else initAll();
  document.addEventListener("shopify:section:load", function (event) {
    init(event.target.querySelector("[data-scene-security-cards]"));
  });

  document.addEventListener("shopify:section:unload", function (event) {
    var section = event.target.querySelector("[data-scene-security-cards]");
    if (section && section.sceneSecurityCards)
      section.sceneSecurityCards.destroy();
  });
})();
